import { FieldError } from 'react-hook-form'
import styled, { css } from 'styled-components'

interface InputProps {
  textColor: string
  error?: FieldError
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
`

export const Label = styled.label`
  margin: 0 0;
  font-size: 1.2rem;
  text-transform: capitalize;
`

export const Input = styled.input<InputProps>`
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 16px;

  color: ${({ textColor }) => textColor};

  &:read-only {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2962ff;
  }

  ${({ error }) => error
    && css`
      box-shadow: 0 0 0.2rem 0.09rem red;
    `}
`

export const Error = styled.p`
  margin: 3px 0 6px 0;
  color: #ab003c;
  max-width: 200px;
  min-height: 24px;
`
